const EntityToActivityNameMapping = {
    /**
     * Event
     */
    EventReservation: 'miscevent',

    /**
     * Flight
     */
    FlightReservation: 'flightdeparture',

    /**
     * Food
     */
    FoodEstablishmentReservation: 'dining',

    /**
     * Invoice
     */
    Invoice: 'invoicedue',

    /**
     * Hotel
     */
    LodgingReservation: 'hotelcheckin',

    /**
     * Parcel Delivery
     */
    ParcelDelivery: 'parceldelivery',

    /**
     * Rental car
     */
    RentalCarReservation: 'rentalcarpickup',

    /**
     * Service reservation
     */
    ServiceReservation: 'serviceappointment',
};

export default EntityToActivityNameMapping;
